import { render, staticRenderFns } from "./GroupTagVirtualList.vue?vue&type=template&id=53c29a32&"
import script from "./GroupTagVirtualList.vue?vue&type=script&lang=ts&"
export * from "./GroupTagVirtualList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports